import React, { useState, useEffect, useCallback } from 'react';
import { galleries } from '../data/portfolioData';
import '../styles/PageTemplate.css';

// justified 版每行的目标高度；flex-basis = 宽高比 × 它，flex 再把余量按同样比例
// 摊掉，于是每行等高且左右撑满。
const ROW_HEIGHT = 200;

// 点击放大。有 full 就用大图，没有就退回缩略图。
function Lightbox({ item, onClose }) {
  const onKey = useCallback((e) => { if (e.key === 'Escape') onClose(); }, [onClose]);
  useEffect(() => {
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';     // 背景别跟着滚
    return () => { document.removeEventListener('keydown', onKey); document.body.style.overflow = prev; };
  }, [onKey]);

  return (
    <div className="lb-backdrop" onClick={onClose} role="dialog" aria-modal="true" aria-label={item.caption || 'Image'}>
      <button type="button" className="lb-close" onClick={onClose} aria-label="Close">×</button>
      <figure className="lb-figure" onClick={e => e.stopPropagation()}>
        <img src={item.full || item.src} alt={item.caption || ''} />
        {item.caption && <figcaption>{item.caption}</figcaption>}
      </figure>
    </div>
  );
}

function GallerySection({ gallery }) {
  const [expanded, setExpanded] = useState(false);
  const [zoomed, setZoomed] = useState(null);
  const justified = gallery.layout === 'justified';
  const grid3 = gallery.layout === 'grid3';

  return (
    <section className="gallery-section">
      <h2 className="pub-toc-section-title gallery-title">{gallery.label}</h2>
      <div className={`gallery-wall-wrap${expanded ? ' expanded' : ''}`}>
        <div className={`gallery-wall${justified ? ' gallery-wall-justified' : ''}${grid3 ? ' gallery-wall-grid3' : ''}`}>
          {gallery.images.map(img => (
            <figure
              className={`gallery-tile${grid3 ? ' is-zoomable' : ''}`}
              key={img.id}
              style={justified && img.ar
                ? { flexGrow: img.ar, flexBasis: `${img.ar * ROW_HEIGHT}px` }
                : undefined}
              onClick={grid3 ? () => setZoomed(img) : undefined}
            >
              <img src={img.src} alt={img.caption || gallery.label} loading="lazy" />
              {img.caption && <figcaption>{img.caption}</figcaption>}
            </figure>
          ))}
        </div>
        {!expanded && <div className="gallery-fade" />}
      </div>
      <button
        type="button"
        className="gallery-toggle"
        onClick={() => setExpanded(x => !x)}
      >
        {expanded ? 'Show less ▴' : 'Show all ▾'}
      </button>
      {zoomed && <Lightbox item={zoomed} onClose={() => setZoomed(null)} />}
    </section>
  );
}

function Portfolio() {
  return (
    <div className="page-container portfolio-page">
      <section className="page-header">
        <h1>Portfolio</h1>
        {/* 位置留着，文案待定 —— &nbsp; 撑住行高，免得标题下面塌一块 */}
        <p className="page-subtitle">&nbsp;</p>
      </section>

      <section className="page-content gallery-page-content">
        {galleries.map(gallery => <GallerySection key={gallery.key} gallery={gallery} />)}
      </section>
    </div>
  );
}

export default Portfolio;
